<template>
    <div class="user_view__images">
        <photo-item 
        v-for="(photo, i) in data"
        :photo="photo" 
        :key="i" 
        class="user_view__images__item">
        
        </photo-item>
    </div>
</template>
<script>
import PhotoItem from './PhotoItem'
export default {
   props:{
       data: Array,
       loading: {
           type: Boolean,
           default: true
        },
       error: Boolean,
       color:{
           type: String,
           default: '#AEB0B9'
       }
   },
   components:{
       'photo-item': PhotoItem
   }
}
</script>


// WEBPACK FOOTER //
// src/components/shared/PhotosList.vue